/* eslint no-console: 0 */

import timeStamp from './timestamp'
import config from './config'
import AppProps from './app-props'

const manualLogLevel = AppProps.get('app.loglevel', 4)

export default function logger(msg, lvl) {
  // 0 = debug + info + warning + error
  // 1 = info + warning + error
  // 2 = warning + error
  // 3 = error
  // 4 = silent
  const isInTest = typeof global === 'object' && typeof global.it === 'function'
  // eslint-disable-next-line
  const logLevel = isInTest ? 4 : manualLogLevel ? manualLogLevel : config.LOGLEVEL;

  const colors = [
    '#181818', // 0  - BLACK
    '#282828', // 1  - GREY1
    '#383838', // 2  - GREY2
    '#484848', // 3  - GREY3
    '#585858', // 4  - GREY4
    '#B8B8B8', // 5  - GREY5
    '#D8D8D8', // 6  - GREY6
    '#E8E8E8', // 7  - GREY7
    '#F8F8F8', // 8  - WHITE

    '#AB4642', // 9  - RED
    '#DC9656', // 10 - ORANGE
    '#F7CA88', // 11 - YELLOW
    '#A1B56C', // 12 - GREEN
    '#86C1B9', // 13 - LIGHT BLUE
    '#7CAFC2', // 14 - BLUE
    '#BA8BAF', // 15 - PURPLE
    '#A16946', // 16 - BROWN
  ]


  const level = lvl || 'info'
  let timestamp
  let bkg

  switch (level) {
  case 'debug':
    if (logLevel === 0) {
      timestamp = `%c ${timeStamp()} - DEBUG: `
      bkg = `background: ${colors[12]}; color: ${colors[8]};`
      return Function.prototype.bind.call(console.log, console, timestamp, bkg, msg)
    }
    break

  case 'info':
    if (logLevel <= 1) {
      timestamp = `%c ${timeStamp()} - INFO: `
      bkg = `background: ${colors[8]}; color: ${colors[14]};`
      return Function.prototype.bind.call(console.log, console, timestamp, bkg, msg)
    }
    break

  case 'warning':
    if (logLevel <= 2) {
      timestamp = `%c ${timeStamp()} - WARNING: `
      bkg = `background: ${colors[11]}; color: ${colors[0]};`
      return Function.prototype.bind.call(console.log, console, timestamp, bkg, msg)
    }
    break

  case 'error':
    if (logLevel <= 3) {
      timestamp = `%c ${timeStamp()} - ERROR: `
      bkg = `background: ${colors[9]}; color: ${colors[8]};`
      return Function.prototype.bind.call(console.log, console, timestamp, bkg, msg)
    }
    break

  default:
    break
  }

  return () => {}
}
